import React from "react";
import { Box, List, ListItem, ListItemText } from "@mui/material";

export default function ExpandedTransaction(props) {
  const currency = (value) => {
    return "AUD " + value.toFixed(2);
  };

  const displayDepositAmount = () => {
    if (props.data.payable) {
      if (!props.data.stripeFee) {
        return (
          <div>
            {props.data.payable && (
              <ListItem>
                <ListItemText
                  primary="Deposit"
                  secondary={currency(props.data.payable)}
                />
              </ListItem>
            )}
          </div>
        );
      } else {
        return (
          <div>
            {props.data.payable && (
              <ListItem>
                <ListItemText
                  primary="Deposit (not incl. Transaction Fee)"
                  secondary={currency(props.data.payable)}
                />
              </ListItem>
            )}
            {props.data.stripeFee && (
              <ListItem>
                <ListItemText
                  primary="Transaction Fee"
                  secondary={currency(props.data.stripeFee)}
                />
              </ListItem>
            )}
          </div>
        );
      }
    } else {
      return displayLegacyDeposit();
    }
  };

  const displayLeaseAmount = () => {
    if (props.data.totalRate && props.data.baseTotalRate) {
      //compare and display
      //no discount
      if (props.data.totalRate == props.data.baseTotalRate) {
        return (
          <ListItem>
            <ListItemText
              primary="Total Lease Amount"
              secondary={currency(props.data.totalRate)}
            />
          </ListItem>
        );
      } else {
        return (
          <div>
            {props.data.totalRate && (
              <ListItem>
                <ListItemText
                  primary="Total Lease Amount (After Discount)"
                  secondary={currency(props.data.totalRate)}
                />
              </ListItem>
            )}

            {props.data.baseTotalRate && (
              <ListItem>
                <ListItemText
                  primary="Total Lease Amount (Before Discount)"
                  secondary={currency(props.data.baseTotalRate)}
                />
              </ListItem>
            )}
          </div>
        );
      }
    } else {
      return displayLegacyTotalRate();
    }
  };

  const displayLegacyTotalRate = () => {
    return (
      <div>
        {props.data.totalRate && (
          <ListItem>
            <ListItemText
              primary="Total Lease Amount (After Discount)"
              secondary={currency(props.data.totalRate)}
            />
          </ListItem>
        )}
      </div>
    );
  };

  const displayLegacyDeposit = () => {
    let depositString = "Deposit";
    depositString += props.data.stripeFee ? " (including Transaction Fee)" : "";
    return (
      <div>
        {props.data.deposit && (
          <ListItem>
            <ListItemText
              primary={depositString}
              secondary={currency(props.data.deposit)}
            />
          </ListItem>
        )}
        {props.data.stripeFee && (
          <ListItem>
            <ListItemText
              primary="Transaction Fee"
              secondary={currency(props.data.stripeFee)}
            />
          </ListItem>
        )}
      </div>
    );
  };

  const displayAppliedRefcode = () => {
    return (
      <div>
        {props.data.referralCodeApplied && (
          <ListItem>
            <ListItemText
              primary="Referral Code Applied"
              secondary={props.data.referralCodeApplied.code}
            />
          </ListItem>
        )}
      </div>
    );
  };

  return (
    <Box sx={{ p: 1.25 }}>
      <List>
        {displayLeaseAmount()}
        {displayDepositAmount()}
        {displayAppliedRefcode()}
      </List>
    </Box>
  );
}
